import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { adminApi } from "@/lib/adminApi";

export const RequireAdmin = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    adminApi
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() =>
        adminApi
          .post("/auth/refresh")
          .then((r) => setUser(r.data))
          .catch(() => setUser(false))
      );
  }, []);

  if (user === null)
    return (
      <div data-testid="admin-auth-checking" className="min-h-screen bg-[#050505] flex items-center justify-center text-white/50 text-sm">
        Verificando acesso...
      </div>
    );
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
};
